import { motion } from 'framer-motion';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import './Contact.css';
import { FaLeaf, FaEnvelope, FaPhone, FaUser, FaWhatsapp, FaMapMarkerAlt } from 'react-icons/fa';

const Contact = () => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  
  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      // Send data to your backend or email service
      const response = await fetch('https://your-backend-api.com/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setSubmitSuccess(true);
        reset();
        // You can also send an email notification to yourself here
      } else {
        throw new Error('Submission failed');
      }
    } catch (error) {
      alert('There was an error submitting your message. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="floral-bg-overlay"></div>
      <motion.div 
        className="contact-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="contact-info">
          <h2>
            <FaLeaf className="icon-spin" /> Contact Our Team
          </h2>
          <p className="floral-text">
            Have questions about our preserved blooms or interested in a custom arrangement? 
            Reach out to our dedicated team members:
          </p>
          
          <div className="contact-person">
            <div className="person-card">
              <FaUser className="person-icon" />
              <h3>Yash Khaitan</h3>
              <p><FaPhone className="contact-icon" /> +971 52 768 2302</p>
              <p>
                <a href="https://wa.me/971527682302" target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp className="whatsapp-icon" /> WhatsApp
                </a>
              </p>
              <p><FaEnvelope className="contact-icon" /> yash@ncbyinfuse.com</p>
            </div>
            
            <div className="person-card">
              <FaUser className="person-icon" />
              <h3>Monika Modi Khaitan</h3>
              <p><FaPhone className="contact-icon" /> +971 50 346 7035</p>
              <p>
                <a href="https://wa.me/971503467035" target="_blank" rel="noopener noreferrer">
                  <FaWhatsapp className="whatsapp-icon" /> WhatsApp
                </a>
              </p>
              <p><FaEnvelope className="contact-icon" /> monika@ncbyinfuse.com</p>
            </div>

            <div className="person-card full-width">
              <FaMapMarkerAlt className="person-icon" />
              <h3>Our Warehouse Address</h3>
              <p>Natures Creations by INFUSE Trading LLC</p>
              <p>Street 24B, Al Quoz Industrial Area 1</p>
              <p>Dubai, United Arab Emirates</p>
            </div>
          </div>
          
          <div className="floral-divider"></div>
        </div>
        
        <form onSubmit={handleSubmit(onSubmit)} className="contact-form">
          <h3 className="form-title">Or Send Us a Message Directly</h3>
          
          <div className="form-group">
            <label htmlFor="name">
              <FaLeaf className="form-icon" /> Name
            </label>
            <input
              id="name"
              type="text"
              {...register("name", { required: "Name is required" })}
              className={errors.name ? 'error' : ''}
              placeholder="Your name"
            />
            {errors.name && <span className="error-message">{errors.name.message}</span>}
          </div>
          
          <div className="form-group">
            <label htmlFor="email">
              <FaLeaf className="form-icon" /> Email
            </label>
            <input
              id="email"
              type="email"
              {...register("email", { 
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address"
                }
              })}
              className={errors.email ? 'error' : ''}
              placeholder="Your email"
            />
            {errors.email && <span className="error-message">{errors.email.message}</span>}
          </div>
          
          <div className="form-group">
            <label htmlFor="phone">
              <FaLeaf className="form-icon" /> Phone (Optional)
            </label>
            <input
              id="phone"
              type="tel"
              {...register("phone")}
              placeholder="Your phone number"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="message">
              <FaLeaf className="form-icon" /> Message
            </label>
            <textarea
              id="message"
              rows="5"
              {...register("message", { 
                required: "Message is required",
                minLength: {
                  value: 10,
                  message: "Message must be at least 10 characters"
                }
              })}
              className={errors.message ? 'error' : ''}
              placeholder="Tell us about your floral needs..."
            ></textarea>
            {errors.message && <span className="error-message">{errors.message.message}</span>}
          </div>
          
          <motion.button 
            type="submit"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              'Sending...'
            ) : (
              <>
                <FaLeaf className="button-icon" /> Send Message
              </>
            )}
          </motion.button>
          
          {submitSuccess && (
            <div className="success-message">
              Thank you! Your message has been sent. We'll get back to you soon.
            </div>
          )}
        </form>
      </motion.div>
    </section>
  );
};

export default Contact;